import React from 'react';
import RedesignLayout from '../components/redesign/RedesignLayout';

type WrapArgs = {
  element: React.ReactElement;
  props: { location: { pathname: string } };
};

/** Public pages share the redesign nav, footer, and type. Admin and the homepage bring their own shell. */
export const wrapPageElement = ({ element, props }: WrapArgs) => {
  const path = props.location?.pathname || '/';
  if (path === '/' || path.startsWith('/admin')) return element;
  return (
    <RedesignLayout seo={false} inner>
      {element}
    </RedesignLayout>
  );
};
